import { render, staticRenderFns } from "./tuijian-dingyue.vue?vue&type=template&id=5308335f&"
import script from "./tuijian-dingyue.vue?vue&type=script&lang=js&"
export * from "./tuijian-dingyue.vue?vue&type=script&lang=js&"
import style0 from "./tuijian-dingyue.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports